import { GreenroomUpdateProfileMask } from '@/types/greenroom/profile.types';
import { Put } from '../helpers';

const InitializeGreenroomProfileMask = async (
  greenroomMeetingId: number,
  email: string,
  token: string
): Promise<GreenroomUpdateProfileMask[]> => {
  return Put({
    host: import.meta.env.VITE_GREENROOM_APP_SYNC_HOST,
    url: `/v1/room/${greenroomMeetingId}/created-invites/${email}`,
    headers: {
      'id-token': token,
      'bl-global-resource': 'false',
    },
  });
};

export default InitializeGreenroomProfileMask;
